'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (client) {
    return (
        /**
         * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
         * @param {Object} apolloParams The apollo request params, depending on the type
         * @returns {Promise} promise A promise from a call to either apolloClient.query
         *                    or apolloClient.mutate, depending on the type
         */
        function (type, apolloParams) {
            if (_constants.QUERY_TYPES.includes(type)) {
                return client.query((0, _extends3.default)({}, apolloParams, {
                    fetchPolicy: 'network-only'
                }));
            }

            if (_constants.MUTATION_TYPES.includes(type)) {
                return client.mutate(apolloParams);
            }

            throw new Error('Unsupported fetch action type ' + type);
        }
    );
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/getApolloPromise.js
// module id = 928
// module chunks = 0